
import { useUserPhoto } from "@hooks/useUserPhoto";
import { useAtomValue } from "jotai";
import { isAuthenticatedAtom } from "@store/HostAtoms";

const PostAuthInitializer = () => {
  const isAuthenticated = useAtomValue(isAuthenticatedAtom);

  useUserPhoto(isAuthenticated);

  return null;
};

export default PostAuthInitializer;
